
import { useAuth } from '@common/auth/use-auth';
import {Trans} from '@common/i18n/trans';
import { useTrans } from '@common/i18n/use-trans';
import { Button } from '@common/ui/buttons/button';
import React, {Fragment, ReactNode, useCallback, useEffect, useState} from 'react';
import { FormTextField, TextField } from '@common/ui/forms/input-field/text-field/text-field';

import {useForm, useFormContext} from 'react-hook-form';
import {Form} from '@common/ui/forms/form';
import { useUwAction } from '../requests/use-demo-uw';
import { FileWithPath, useDropzone } from 'react-dropzone';
import { formatBytes } from '@common/utils/number/byte-format';
import { UwCustomPage } from './uw-custom-page';

export interface FilePayload {
  files: Array<File>;
  prompt: string;
  // lender_id: string|number;
}

export function UWPage({changeLender}: any) {
  const {trans} = useTrans();
  const {user} = useAuth();
  
  const [newMessage, setNewMessage] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    setMessage(newMessage);
  }, [newMessage])

  window.Echo.channel('uw').listen('.process', (e: any) => {
    if (e.data != undefined) {
      const item = e.data;
      if (item.status) {
        setMessage(item.status);
      }
      if (item.text) {
        setMessage(item.text);
      }
    }
  });


  return (
    <Fragment>
      <div className='flex gap-10 m-20'>
        <div className='w-[30%] pr-10 border-r-1 sticky'>
          <UWPrompt newMessage={setNewMessage} changeLender={changeLender}/>
        </div>
        <div className='w-[70%]'>
          
          <UwCustomPage key={message} message={message}/>
        </div>
      </div>
      
    </Fragment>
  );
}


function UWPrompt({newMessage, changeLender}:{newMessage: any, changeLender: any}) {

  // const {formId} = useFormContext();
  
  const form = useForm<FilePayload>({
    defaultValues: {
    },
  });

  
  const sendUW = useUwAction(form);
  const [isEnable, setIsEnable] = useState(false);

  return (
    <Form
          // id={formId}
          form={form}
          onSubmit={value => {
            sendUW.mutate(value, {
              onSuccess: () => {
              },
            });
          }}
        >
          <CrupdateProductUWFields isEnable={setIsEnable}/>
          <Button
          type="submit"
          variant="flat"
          color="primary"
          disabled={sendUW.isPending || !isEnable}
        >
          <Trans message="Process" />
        </Button>
        </Form>
  );
}

export function CrupdateProductUWFields({isEnable, itemFiles}:{isEnable?: any, itemFiles?: any}) {
 
  // const {data: mylenders} = useMyLenders();
  // const lenders = mylenders?.lenders;

  const form = useFormContext<FilePayload>();

  const [files, setFiles] = useState([]);
  
  const onDrop = useCallback((acceptedFiles: any) => {

    setFiles(acceptedFiles);
    if (isEnable) {
      isEnable(true);
    }

	}, []);

  useEffect(() => {
      form.setValue('files', files);
  }, [form, files]);

  return (
    <Fragment>
      <FormTextField
        name="prompt"
        label={<Trans message="UW Prompt" />}
        inputElementType="textarea"
        rows={4}
        className="mb-20"
      />

      <UWFile onDrop={onDrop} itemFiles={itemFiles}/>

    </Fragment>
  );
}

function UWFile({onDrop, itemFiles}: {onDrop: any, itemFiles: any}) {

  const max_file_upload = 24;

  const {
    acceptedFiles,
    getRootProps,
    getInputProps
  } = useDropzone({
    accept: {
      'application/pdf': []
    },
    onDrop,
    maxFiles: max_file_upload,
    multiple: true
  });

  return (
    <section>
      <div {...getRootProps({ className: 'dropzone h-200' })}>
        
        <input name='files' {...getInputProps()} />

        <p>Drag 'n' drop one file here, or click to select template</p>
        <em>(Only pdf will be accepted and {max_file_upload} file are the maximum number of one file you can drop here)</em>
      </div >
        <div>
        <h4 className='h-40 t-40'><strong>Uploaded file</strong></h4>
        <div className="table-wrp block flex flex-col overflow-y-scroll">
          <table className="w-full file">
            <thead className="bg-white border-b sticky top-0 bg-slate-300">
              <tr className='bg-gray-300'>
                <th scope="col" className="bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 pl-20 text-left">
                  File Name
                </th>
                <th scope="col" className="bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 text-left">
                  Size
                </th>
                {/* <th scope="col" className="bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 text-left">
                  Status
                </th> */}
                {/* <th></th> */}
              </tr>
            </thead>
            <tbody className="h-96 overflow-y-auto">
              {acceptedFiles.map((file: FileWithPath, index) => (
                <tr key={file.path} className="bg-white border-b transition duration-300 ease-in-out hover:bg-gray-100">
                  <td className="text-sm font-extrabold text-gray-900 font-light px-6 py-4 pl-20 whitespace-nowrap">
                  {index+1}. {file.path}
                  </td>
                  <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">{formatBytes(file.size)}</td>
                </tr>
              ))}

              {acceptedFiles.length == 0 && itemFiles && itemFiles.map((file: any, index: number) => (
                <tr key={file.id} className="bg-white border-b transition duration-300 ease-in-out hover:bg-gray-100">
                  <td className="text-sm font-extrabold text-gray-900 font-light px-6 py-4 pl-20 whitespace-nowrap">
                  {index+1}. {file.name}
                  </td>
                  <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">{formatBytes(file.size)}</td>
                  {/* <td>
                    <span>
                      {file.status}
                    </span>
                  </td> */}

                  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

